export const isYoutubeURL = (url: string | undefined) => {
  if (!url) {
    return false;
  }

  return (
    url.startsWith("https://youtube") || url.startsWith("https://www.youtube")
  );
};
